





// fix multiple "add-to-cart" clicks duplicating option costs

if (typeof(shopstorm) !== 'undefined' && typeof(shopstorm.apps) !== 'undefined' && typeof(shopstorm.apps.productCustomizer) !== 'undefined') {
  shopstorm.apps.productCustomizer.preventDuplicateFormSubmissions = true;
}


// parses option description as html on page load


shopstorm.apps.productCustomizer.jqueryLoadedCallback = function($) {
  if (shopstorm.apps.productCustomizer.xLoadedCallbackRun != true) {
        
        $('.product-customizer-option-description').each(function(){
            $(this).html( $.parseHTML( $(this).text() ) );
        });
        
    shopstorm.apps.productCustomizer.xLoadedCallbackRun = true;
  }
};


(function() {

  	var customizerInputText = $('.product-customizer-option').find('input[type="text"]');
  
  	customizerInputText.attr( "autocomplete", "off");
  
    customizerInputText.on('keypress',function(event) {
      	var regex =  /[-A-Za-z0-9()?!:$",@#/&.*'% ]/g;
        var key = String.fromCharCode(event.which);

        if ( event.keyCode == 8 || event.keyCode == 37 || event.keyCode == 39 || regex.test(key)) {
            return true;
        } 
        return false;      
    });	
  
    customizerInputText.on("paste",function(e) {
        e.preventDefault();
    });    
  
  var highlightedText = "";  
  customizerInputText.mouseup(function() {
    if (window.getSelection) {
        highlightedText = window.getSelection().toString();
    } 
    else if (document.selection && document.selection.type != "Control") {
        highlightedText = document.selection.createRange().text;
    }
  
  });
 
    var leftRowPrint = $("input[name='properties[Left Row Print]']"),
        rightRowPrint = $("input[name='properties[Right Row Print]']");  

  	var leftRowLength = 0, 
        rightRowLength = 0,  
		totalCharLength = 0;
  
  
  	leftRowPrint.attr('maxlength',35);
  	rightRowPrint.attr('maxlength',35);
  
      leftRowPrint.on('keypress', function(event) {

            leftRowLength = $(this).val().length;
            if ( rightRowPrint.val().length != 0 ) {
                rightRowLength = rightRowPrint.val().length + 1;
            } 

            totalCharLength = leftRowLength + rightRowLength;
            if ( totalCharLength > 35 ) {
                if (window.getSelection) {
                    highlightedText = window.getSelection().toString();
                  	console.log('hello firefox' + highlightedText);
                }               
              
                if(highlightedText != "") {
                  	console.log('highlighted firefox');
                  	highlightedText = "";
                } else if ( event.keyCode == 8 || event.keyCode == 46 ) {
                  	highlightedText = "";                  
              		return true;                  
                } else {             
               	 return false;        
                }
            }
        
        
      });
  
      rightRowPrint.on('keypress', function(event) {
            rightRowLength = $(this).val().length;
            if ( leftRowPrint.val().length != 0 ) {
                leftRowLength = leftRowPrint.val().length + 1;
            } 

            totalCharLength = leftRowLength + rightRowLength;
            if ( totalCharLength > 35 ) {
                if (window.getSelection) {
                    highlightedText = window.getSelection().toString();
                  	console.log(highlightedText);
                }               
              
                if(highlightedText != "") {
                    console.log("text highlighted.");  
                  	highlightedText = "";
                } else if ( event.keyCode == 8 || event.keyCode == 46 ) {
              		return true;                  
                } else {             
               	 return false;        
                }      
            } 
         
        
      });  

  
})();
